import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import Banner from './banner';
import Footer from './footer';
import LogoMain from './logo-main';
import PropertyLogosMobile from './property-logos-mobile';
import Util from '../../../../common/util'

const styles = (theme) => ({
  container: {
    display: 'flex',
    minHeight: '100vh',
    height: '100%',
    flexDirection: 'column',
  }
});

class Branding extends Component {
  render() {
    const params = Util.queryToObject(window.location.search);

    const adChoicesUrl = window.globals && window.globals.gidLinkAdChoices ? window.globals.gidLinkAdChoices : 'https://www.golfnow.com/ad-choices';
    const caNotice = window.globals && window.globals.gidLinkCaNotice ? window.globals.gidLinkCaNotice : 'http://www.golfnow.com/ca-notice';
    const doNotSellUrl = window.globals && window.globals.gidLinkDoNotSell ? window.globals.gidLinkDoNotSell : 'https://www.golfnow.com/do-not-sell';
    const privacyPolicyUrl = window.globals && window.globals.gidLinkPrivacyPolicy ? window.globals.gidLinkPrivacyPolicy : 'https://www.golfnow.com/privacy-policy';
    const privacyOptOut = window.globals && window.globals.gidLinkPrivacyOptOut ? window.globals.gidLinkPrivacyOptOut : 'https://www.golfnow.com/privacy-opt-out';
    const termsAndConditionsUrl = window.globals && window.globals.gidLinkTermsAndConditions ? window.globals.gidLinkTermsAndConditions : 'https://www.golfnow.com/support/about-us/terms';

    const bannerLink = window.globals && window.globals.gidBannerLink ? window.globals.gidBannerLink : null;
    const bannerMessage = window.globals && window.globals.gidBannerMessage && window.globals.gidBannerMessage !== 'NULL' ? window.globals.gidBannerMessage : null;

    let banner = <Banner
      link={bannerLink}
      message={bannerMessage}
    />;

    let footer = (
      <Footer
        adChoicesUrl={adChoicesUrl}
        caNotice={caNotice}
        doNotSellUrl={doNotSellUrl}
        privacyPolicyUrl={privacyPolicyUrl}
        privacyOptOut={privacyOptOut}
        termsAndConditionsUrl={termsAndConditionsUrl}
      />
    );
    let mainLogo = <LogoMain />;
    let mobilePropteryLogos = <PropertyLogosMobile />;

    if (params.hasOwnProperty('backgroundColor')) {
      document.body.style.backgroundColor = `#${params['backgroundColor']}`;
    }

    if (params.hasOwnProperty('noBanner') || this.props.noBanner) {
      banner = null;
    }

    if (params.hasOwnProperty('noLogos') || this.props.noLogos) {
      mainLogo = null;
    }

    if (params.hasOwnProperty('noProperties') || this.props.noProperties) {
      mobilePropteryLogos = null;
    }

    if (params.hasOwnProperty('noFooter') || this.props.noFooter) {
      banner = null;
      footer = null;
    }

    return (
      <div className={this.props.classes.container}>
        {banner}
        {mainLogo}
        {this.props.children}
        {mobilePropteryLogos}
        {footer}
      </div>
    );
  }
}

export default withStyles(styles)(Branding);
